<template lang="html">
    <div>
        <div class="form-group d-flex">

            <div class="col-sm-12">
                <label>Name</label>
                <div class="d-flex align-items-center">
                    <input type="text" class="w-50" v-model="segment.name" placeholder="Name here" />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import { mapActions, mapGetters} from 'vuex'

export default {
    props:{
        segment:{
            type: Object
        }
    },
    computed:{
        ...mapGetters([
        ]),
    },
    methods: {
        ...mapActions([
            'closeModal',
            'showUpgradePlanPopup'
        ]),
    },
    components:{
        vSelect: extendedVSelect
    }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// segmentsForm.vue?a55ba596